import { render } from "./DefaultSelection.vue?vue&type=template&id=6dc6cf8e&scoped=true"
import script from "./DefaultSelection.vue?vue&type=script&lang=js"
export * from "./DefaultSelection.vue?vue&type=script&lang=js"

import "./DefaultSelection.vue?vue&type=style&index=0&id=6dc6cf8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc6cf8e"]])

export default __exports__